import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type BuddyPreferenceResponse =
  paths['/api/v1/buddy_preferences']['get']['responses'][200]['content']['application/json'];

export type RestoreSwipeResponse =
  paths['/api/v1/buddy_preferences/restore_swipe']['post']['responses'][200]['content']['application/json']['buddy_preference'];

export async function getBuddyPreference(): Promise<BuddyPreferenceResponse> {
  const { data, error } = await client.GET('/api/v1/buddy_preferences', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getBuddyPreference');

  return data;
}

export async function restoreSwipe(adUnitId: string): Promise<RestoreSwipeResponse> {
  const { data, error } = await client.POST('/api/v1/buddy_preferences/restore_swipe', {
    headers: authHeaders(),
    body: {
      ad_unit_id: adUnitId
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from restoreSwipe');

  return data.buddy_preference;
}
